
import {defineComponent, onMounted, PropType, ref, Ref} from "vue";

import CatalogService from "@/services/CatalogService";
import {useStore} from './store';
import {FilterActionTypes} from './store/modules/filter/action-types';
import {ProductActionTypes} from "./store/modules/product/action-types";
import {TranslationActionTypes} from "./store/modules/translation/action-types";
import {Translations} from "@/types";

import FilterHolder from "./components/filter/FilterHolder.vue";
import FilterSelection from "./components/filter/FilterSelection.vue";
import CategorySort from "./components/controls/CategorySort.vue";
import ProductList from "./components/products/ProductList.vue";
import Pager from "./components/controls/Pager.vue";
import ButtonOpenFilter from "@/components/controls/ButtonOpenFilter.vue";
import {mapGetters} from "vuex";

declare global {
    interface Window {
        preloadedProductsForVue: any | null
    }
}

export default defineComponent({
    name: "StoreCatalog",
    components: {
        ButtonOpenFilter,
        FilterHolder,
        FilterSelection,
        CategorySort,
        ProductList,
        Pager
    },
    props: {
        translations: {
            type: Object as PropType<Translations>,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            'loadingProductsLabel': 'getLoadingProductsLabel',
            'openFilterLabel': "getOpenFilterLabel",
        })
    },
    setup(props) {
        const root: Ref<HTMLElement | null> = ref(null);
        const isLoadingProducts: Ref<boolean> = ref(true);
        const isLoadingFilters: Ref<boolean> = ref(true);
        const store = useStore();

        function teleportExternalPartsIfExists(externalPart: Element | null, slot?: Element | null) {
            if (!slot || !externalPart) {
                return;
            }
            if (externalPart) {
                slot.replaceWith(externalPart);
                return;
            }

            slot.remove(); // Pokud neexistuje external part, slot se odebere, ať tam nezůstává prázdný div
        }

        onMounted(() => {
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="category-nav"]'), root.value?.querySelector('[data-slot="category-nav"]'));
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="banner"]'), root.value?.querySelector('[data-slot="banner"]'));
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="category-header"]'), root.value?.querySelector('[data-slot="category-header"]'));
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="sub-categories"]'), root.value?.querySelector('[data-slot="sub-categories"]'));
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="top-seller"]'), root.value?.querySelector('[data-slot="top-seller"]'));
            teleportExternalPartsIfExists(document.querySelector('[data-slot-id="recommended-list"]'), root.value?.querySelector('[data-slot="recommended-list"]'));

            store.dispatch(TranslationActionTypes.SET_TRANSLATIONS, props.translations);

            const preloadedProducts = window?.preloadedProductsForVue
            if (preloadedProducts) {
                store.dispatch(ProductActionTypes.SET_PRODUCTS, preloadedProducts).then(() => isLoadingProducts.value = false);
            }
        })

        CatalogService.prepareFilterData()
            .then(result => {
                store.dispatch(FilterActionTypes.SET_FILTER, result).then(() => isLoadingFilters.value = false);
                if (isLoadingProducts.value) {
                    store.dispatch(ProductActionTypes.SET_PRODUCTS, result).then(() => isLoadingProducts.value = false);
                }
            })
            .catch(error => console.error(error));

        function openFilterModal(): void {
            store.dispatch(FilterActionTypes.SET_IS_OPENED_FILTER_MODAL, true);
        }

        return {
            root,
            isLoadingProducts: isLoadingProducts,
            isLoadingFilters: isLoadingFilters,
            openFilterModal,
        }
    }
});
